(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('inquiry', {
            parent: 'app',
            url: '/inquiry',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/master/application/caretreeApplication.html',
                    controller: 'CaretreeApplicationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caretreeApplication');
                    return $translate.refresh();
                }]
            }
        }).state('inquiry.validation', {
            parent: 'inquiry',
            url: '/show',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/master/application/dialog/contentValidation.html',
                    controller: 'ContentValidationController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('inquiry', null, { reload: true });
                }, function() {
                    $state.go('inquiry');
                });
            }]
        });
    }
})();
